import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const leaveRecallService = {
  // Fetches leave requests that are eligible to be recalled
  getRecallableByEmployee: async (employeePersonalInformationId) => {
    return await axios.get(`${domain}/api/LeaveRecall/recallable/${employeePersonalInformationId}`, { headers });
  },

  // Fetches history of already recalled leaves
  getRecallHistory: async (employeePersonalInformationId) => {
    return await axios.get(`${domain}/api/LeaveRecall/history/${employeePersonalInformationId}`, { headers });
  },

  // Submits the recall request
  createRecall: async (payload) => {
    // Payload contains { requestId, reason, employeePersonalInformationId }
    return await axios.post(`${domain}/api/LeaveRecall`, payload, { headers });
  }
};

export default leaveRecallService;